
import { useEffect, useState } from 'react';

interface ScoreDisplayProps {
  score: number;
  onReset: () => void;
}

export default function ScoreDisplay({ score, onReset }: ScoreDisplayProps) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (score > 0) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 300);
      return () => clearTimeout(timer);
    }
  }, [score]);

  return (
    <section className="py-8">
      <div className="container mx-auto px-6">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-8 max-w-2xl mx-auto border-4 border-amber-400">
          <div className="text-center">
            <h2 className="text-lg font-semibold text-gray-600 mb-2">Total Cookies</h2>
            <div className={`text-7xl font-bold text-amber-600 transition-all duration-300 ${animate ? 'scale-110' : 'scale-100'}`}>
              {score.toLocaleString()}
            </div>
            <div className="mt-4 flex items-center justify-center gap-2">
              <span className="text-5xl">🍪</span>
              <span className="text-2xl font-medium text-gray-700">Cookies Baked</span>
            </div>
            <button
              onClick={onReset}
              className="mt-6 px-8 py-3 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              🔄 Reset Game
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
